export const paymentConstants = {
  SET_PAYPAL_ACCESS_TOKEN: "SET_PAYPAL_ACCESS_TOKEN"
};
